import useEdition from '@/hooks/useEdition';
import type { AppRouteRecordRaw } from './types';

const modules = import.meta.globEager('./modules/*.ts');
// const externalModules = import.meta.globEager('./externalModules/*.ts');

/**
 * @msg: 格式化路由
 * @param {any} _modules
 * @param {RouteRecordNormalized} result
 * @return {*}
 */
function formatModules(_modules: any, result: AppRouteRecordRaw[]) {
  Object.keys(_modules).forEach((key) => {
    const defaultModule = _modules[key].default;
    if (!defaultModule) return;
    const moduleList = Array.isArray(defaultModule)
      ? [...defaultModule]
      : [defaultModule];
    result.push(...moduleList);
  });
  return result;
}

function filterRoutesByEdition(
  routes: AppRouteRecordRaw[]
): AppRouteRecordRaw[] {
  const { isFeatureDisabled, isRouteDisabled } = useEdition();
  return routes
    .filter((route) => {
      const featureKey = route.meta?.featureKey as string | undefined;
      if (isRouteDisabled(route.name as string)) return false;
      if (featureKey && isFeatureDisabled(featureKey)) return false;
      return true;
    })
    .map((route) => {
      const children = route.children
        ? filterRoutesByEdition(route.children)
        : undefined;
      return {
        ...route,
        ...(children ? { children } : {}),
      };
    });
}

export const appRoutes: AppRouteRecordRaw[] = filterRoutesByEdition(
  formatModules(modules, [])
);

// export const appExternalRoutes: RouteRecordNormalized[] = formatModules(
//   externalModules,
//   []
// );

// Avoid circular references, put here

export const DEFAULT_ROUTE_NAME = 'HomepageIndex';

export const DEFAULT_ROUTE = {
  title: 'Homepage',
  name: DEFAULT_ROUTE_NAME,
  fullPath: '/discover/homepage',
};
